import React, {FC, MouseEvent, ReactElement, useCallback, useState} from 'react';
import {CircularProgress} from "@mui/material";

export interface LoadingLinkProps extends Omit<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, "href"> {
    onClick: () => Promise<void>
}

export const LoadingLink: FC<LoadingLinkProps> = (props): ReactElement => {
    const [loading, setLoading] = useState(false);

    const onClick = useCallback(async (event: MouseEvent) => {
        event.preventDefault()
        try {
            setLoading(true)
            await props.onClick();
        } finally {
            setLoading(false)
        }
    }, [props]);
    return <>
        {loading && <CircularProgress size={"0.7rem"}/>}
        {!loading && <a href={""} {...props} onClick={onClick}/>}
    </>
};

export default LoadingLink;